import { supabase } from '@/features/sistema/services/supabaseClient';

const THREAD_READS_TABLE = 'app_thread_reads';
const MARK_THREAD_READ_RPC = 'fn_app_thread_mark_read';

export type ThreadReadRecord = {
  thread_id: string;
  usuario_id: string;
  last_read_at: string;
};

export async function markThreadRead(threadId: string) {
  if (!threadId) return;

  const { error } = await supabase.rpc(MARK_THREAD_READ_RPC, {
    p_thread_id: threadId,
  });

  if (error) {
    throw error;
  }
}

export async function deleteThreadRead(threadId: string, userId?: string) {
  if (!threadId) return;

  let query = supabase.from(THREAD_READS_TABLE).delete().eq('thread_id', threadId);

  if (userId) {
    query = query.eq('usuario_id', userId);
  }

  const { error } = await query;

  if (error) {
    throw error;
  }
}

export async function listThreadReadsByThread(threadId: string) {
  if (!threadId) {
    return [] as ThreadReadRecord[];
  }

  const { data, error } = await supabase
    .from(THREAD_READS_TABLE)
    .select('thread_id,usuario_id,last_read_at')
    .eq('thread_id', threadId);

  if (error) {
    throw error;
  }

  return (data ?? []) as ThreadReadRecord[];
}

export async function listThreadReadsByThreads(threadIds: string[], filters?: { userIds?: string[]; userId?: string }) {
  if (!threadIds?.length) {
    return [] as ThreadReadRecord[];
  }

  let query = supabase
    .from(THREAD_READS_TABLE)
    .select('thread_id,usuario_id,last_read_at')
    .in('thread_id', threadIds);

  if (filters?.userIds?.length) {
    query = query.in('usuario_id', filters.userIds);
  } else if (filters?.userId) {
    query = query.eq('usuario_id', filters.userId);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data ?? []) as ThreadReadRecord[];
}

